import ls from "../services/localStorage";
import { types } from "../constants/constants";

export const getApiServices = (attributes: any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes).length ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : '';
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}services${query}`, {
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const getApiService = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}services/id/${attributes._id}`, {
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const postApiCreateService = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}service/create`, {
    method: "POST",
    headers: {
      token: token !== null ? token : '',
      "Content-Type": "application/json"
    },
    body: JSON.stringify(attributes)
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const putApiUpdateService = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}services/update/id/${attributes.service._id}`, {
    method: "PUT",
    headers: {
      token: token !== null ? token : '',
      "Content-Type": "application/json"
    },
    body: JSON.stringify(attributes)
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const deleteApiService = (id: string): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}services/delete/id/${id}`, {
    method: "DELETE",
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};
